import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { GtmService } from '../../../../shared/cardholders-core/services/gtm.service';
import { UiHelperService } from '../../../../shared/cardholders-core/services/ui-helper.service';
import { IContentResponse } from '../../interfaces/IContentResponse.interface';
import { IDirectDebitBenefitDataRequest } from '../../interfaces/IDirectDebitBenefitDataRequest.interface';
import { IDirectDebitBenefitData } from '../../interfaces/IDirectDebitBenefitDataResponse.interface';
import { DirectDebitService } from '../../services/direct-debit.service';

@Component({
    selector: 'app-calculator-result',
    templateUrl: './calculator-result.component.html',
    styleUrls: ['./calculator-result.component.scss']
})
export class CalculatorResultComponent implements OnInit, OnDestroy {
    directDebitBenefitData: IDirectDebitBenefitData;
    contents: IContentResponse;
    subs: Subscription[] = [];

    constructor(
        private directDebSrv: DirectDebitService,
        private gtmService: GtmService,
        private router: Router,
        private activeRoute: ActivatedRoute,
        private uiHelper: UiHelperService
    ) {}
    ngOnDestroy(): void {
        this.subs.forEach((s) => {
            s.unsubscribe();
        });
    }

    get bgImg(): string {
        return `url(${
            this.uiHelper.IsMobile() ? this.contents.wwyg.headerMobileImage : this.contents.wwyg.headerDesktopImage
        }) 0% 0%  no-repeat`;
    }

    ngOnInit(): void {
        this.gtmService.pushDirectDebit('calculator-result', 'load');
        this.subs.push(this.directDebSrv.contents$.subscribe((content) => (this.contents = content)));

        this.directDebitBenefitData = this.directDebSrv.directDebitBenefitData;
        this.gtmService.pushDirectDebit('calculator-result', this.directDebitBenefitData.userCards.length.toString());

        this.gtmService.pushDirectDebit(
            'calculator-result',
            this.directDebitBenefitData.userCards.map((o) => o.benefitName).join(' ')
        );
    }

    goToTransfer(): void {
        this.gtmService.pushDirectDebit('calculator-result', 'lets start');
        this.directDebSrv.next = 'check-for-card';
        this.router.navigate(['../check-for-card'], { relativeTo: this.activeRoute });
    }
}
